import { CountrySelectionService } from './../../../services/country-selection/country-selection.service';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WorkbenchModule } from '@workbench/angular';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'app-country-selector',
    standalone: true,
    imports: [WorkbenchModule, TranslateModule, CommonModule],
    templateUrl: './country-selector.component.html',
    styleUrl: './country-selector.component.scss',
})
export class CountrySelectorComponent implements OnInit {
    public countryList: any[] = [{ title: '', code: '' }];
    public hasUserConfirmedCountry: boolean = false;
    public userOriginCountry = '';
    isSelectedCountrySupported: boolean = false;
    isLoginRedirectionInProgress: boolean = false;

    constructor(private readonly _translationService: TranslationService, private readonly _countrySelectionService: CountrySelectionService) {}

    ngOnInit(): void {
        this.countryList = this._translationService.cpSecrets.countries
            .map((country: any) => {
                return {
                    title: country.name,
                    code: country.code,
                    region: country.region,
                    isSupported: country.flag
                };
            });
    }

    selectCountry(e: any): void {
        this.isLoginRedirectionInProgress = false
        this.isSelectedCountrySupported = false;
        this.userOriginCountry = e?.detail?.value?.label;
        const selectedCountryDetails = this.countryList.find((country: any) => country.title === this.userOriginCountry)
        if (!selectedCountryDetails) {
            this.isSelectedCountrySupported = false
            return;
        }
        if (!selectedCountryDetails?.isSupported) {
                    this.isSelectedCountrySupported = true
        }
    }

    onInputCountryChange(event: any) {
        if (event?.detail?.value === '') {
            this.userOriginCountry = '';
        }
    }

    onCheckBoxSelect(e: any) {
        this.hasUserConfirmedCountry = e?.detail?.checked;
    }

    onCountrySelectClick() {
        this.isLoginRedirectionInProgress = true;
        if (this.userOriginCountry && this.userOriginCountry !== '' && this.hasUserConfirmedCountry) {
            const countryDetails = this.countryList.find(country => country.title === this.userOriginCountry);
            this._countrySelectionService.setCountry(JSON.stringify(countryDetails))
        }
    }
}
